import callApi from "helpers/callApi";

export function getNotificationCenter() {
  return callApi("/notify/notification_center", "GET", { only_active: true });
}

export function getNotificationCenterCounters() {
  return callApi("/notify/notification_center/counters", "GET");
}
